<script lang="ts">
    import { _ } from 'svelte-i18n';

    import SearchInput from '../../../shared/SearchInput.svelte';
    import { filterDashboardTemplatesQuery } from './store';
</script>

<div class="filter">
    <SearchInput
        placeholder={$_('Search by name')}
        query={$filterDashboardTemplatesQuery}
        onChange={() => {}}
        onKeyup={query => {
            $filterDashboardTemplatesQuery = query;
        }}
    />
</div>

<style>
    .filter {
        display: flex;
        flex-direction: row;
        align-items: center;
        /*padding: 0 1rem;*/
        padding: 2px 0;
        border: 1px solid var(--color-gray-300);
        border-radius: 0.5rem;
        column-gap: 10px;
    }
</style>
